import { Report } from '@crops';
import { styled } from '@mui/material/styles';
import DefaultForm from './DefaultForm';

interface IProps {
  userInfo?: Report.TUserDetail;
  isReadOnly?: boolean;
  handleSubmit?: void;
}

const RegisterForm = ({ userInfo, isReadOnly }: IProps) => {
  return (
    <Root>
      <FlexBox>
        <DefaultForm
          value={userInfo?.user_nm}
          userInfo={userInfo?.user_nm}
          label="성명"
          chipBorderWidth="1px 1px 1px 1px"
          inputBorderWidth="0px"
          isReadOnly={isReadOnly}
        />
        <DefaultForm
          value={userInfo?.user_brdt !== null ? userInfo?.user_brdt?.replace(/\./g, '-') : ''}
          userInfo={userInfo?.user_brdt?.replace(/\./g, '-')}
          label="생년월일"
          inputType="date"
          chipBorderWidth="1px 0px 1px 1px"
          isReadOnly={isReadOnly}
        />
        <DefaultForm
          value={userInfo?.biz_no !== null ? userInfo?.biz_no : ''}
          userInfo={userInfo?.biz_no === null ? '' : userInfo?.biz_no}
          label="법인/사업자등록번호"
          chipBorderWidth="1px 0px 1px 1px"
          isReadOnly={isReadOnly}
        />
      </FlexBox>
      <FlexBox>
        <DefaultForm
          value={userInfo?.user_addr}
          userInfo={userInfo?.user_addr}
          label="주소"
          isReadOnly={isReadOnly}
        />
      </FlexBox>
      <FlexBox>
        <DefaultForm
          label="연락처"
          chip
          isBorder
        />
        <DefaultForm
          value={userInfo.home_phone === null ? '' : String(userInfo?.home_phone)}
          userInfo={userInfo?.home_phone === null ? '' : String(userInfo?.home_phone)}
          label="자택"
          isReadOnly={isReadOnly}
        />
        <DefaultForm
          value={userInfo?.mbl_phone === null ? '' : String(userInfo?.mbl_phone)}
          userInfo={userInfo?.mbl_phone === null ? '' : String(userInfo?.mbl_phone)}
          label="핸드폰"
          isReadOnly={isReadOnly}
        />
      </FlexBox>
    </Root>
  );
};

const Root = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1',

  '@media print': {
    width: '100%',
    display: 'inline-block',
  },
}));

const FlexBox = styled('div')(() => ({
  display: 'flex',
  borderBottom: '1px solid #000',
  ':first-of-type': {
    borderTop: '1px solid #000',
  },
  borderLeft: '1px solid #000',
  borderRight: '1px solid #000',
}));

export default RegisterForm;
